import { types } from 'mobx-state-tree'

export const WorkspaceResponse = types.model('WorkspaceResponse').props({
  email: types.string,
  access_code: types.string,
  logo_path: types.maybeNull(types.string),
  company_name: types.maybeNull(types.string),
  display_cobranding: types.maybeNull(types.boolean),
})
